import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

import { Alert } from 'ui';

const ConfidentialAlert = ({ label, message }) => {
  const { t } = useTranslation();

  return (
    <Alert
      message={
        <div>
          <Typography variant="body2">
            <strong>{t(label)}</strong>
          </Typography>
          <Typography variant="body2">{t(message)}</Typography>
        </div>
      }
      variant="error"
    />
  );
};

ConfidentialAlert.propTypes = {
  label: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default ConfidentialAlert;
